export default __webpack_public_path__ + "static/media/staffIcon.c4db0be8.svg";